import * as React from 'react';
import * as ToastPrimitives from '@radix-ui/react-toast';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useToastStore } from '@/components/ui/use-toast';

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <ToastPrimitives.Provider swipeDirection="right">
      {toasts.map((t) => (
        <ToastPrimitives.Root
          key={t.id}
          open
          onOpenChange={(open) => {
            if (!open) dismiss(t.id);
          }}
          className={cn(
            'group pointer-events-auto relative flex w-full items-start justify-between space-x-2 overflow-hidden rounded-lg border p-4 pr-8 shadow-lg transition-all',
            'data-[state=open]:animate-slide-up bg-card text-card-foreground',
            t.variant === 'danger' && 'border-danger/40 bg-danger/5',
            t.variant === 'success' && 'border-success/40 bg-success/5',
            t.variant === 'warning' && 'border-warning/40 bg-warning/5',
          )}
        >
          <div className="grid gap-1">
            {t.title && <ToastPrimitives.Title className="text-sm font-semibold">{t.title}</ToastPrimitives.Title>}
            {t.description && (
              <ToastPrimitives.Description className="text-sm opacity-90">{t.description}</ToastPrimitives.Description>
            )}
          </div>
          <ToastPrimitives.Close className="absolute right-2 top-2 rounded-md p-1 text-muted-foreground hover:text-foreground">
            <X className="h-4 w-4" />
          </ToastPrimitives.Close>
        </ToastPrimitives.Root>
      ))}
      <ToastPrimitives.Viewport className="fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col-reverse gap-2 p-4 sm:bottom-4 sm:right-4 sm:max-w-[420px]" />
    </ToastPrimitives.Provider>
  );
}
